<template>
	<el-card class="ring-chart-card">
		<div class="chart-title">债权统计(共{{ total }}个)</div>
		<div class="chart-wrapper" ref="chart"></div>
	</el-card>
</template>

<script>
	import * as echarts from 'echarts';
	import apis from "@/http/apis";
	import chartClickMixin from "@/views/index/components/handlemixin.js"; // 引入点击事件
	export default {
		name: 'RingChart',
		mixins: [chartClickMixin],
		data() {
			return {
				chart: null,
				total: 0
			};
		},
		mounted() {
			this.initChart();
			this.fetchData();
		},
		beforeDestroy() {
			if (this.chart) {
				this.chart.dispose();
			}
		},
		methods: {
			initChart() {
				// 初始化图表
				this.chart = echarts.init(this.$refs.chart);

				// 图表配置
				const option = {
					// tooltip: {
					// 	trigger: 'item',
					// 	formatter: '{a} <br/>{b}: {c} ({d}%)'
					// },
					legend: {
						bottom: '10',
						left: 'center',
						textStyle: {
							color: '#ffffff'
						},
						itemWidth: 12, // 控制图例方块的宽度
						itemHeight: 12, // 控制图例方块的高度
						itemStyle: {
							borderWidth: 0 // 可选：去掉边框
						},
						formatter: (name) => `${name}(个)`					},
					series: [{
						name: '',
						type: 'pie',
						radius: ['40%', '50%'],
						// center: ['50%', '45%'],
						center: ['50%', '35%'], // 圆环中心位置，向上调整到40%
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 0, // 圆角，实现胶囊效果
							borderColor: '#fff',
							borderWidth: 0
						},
						label: {
							show: true,
							position: 'outside',
							formatter: (params) => {
								return `{title|${params.name}}\n{value|${params.value}个}`;
							},
							rich: {
								title: {
									fontSize: 10,
									color: '#fff',
									padding: [2, 0, 0, 0]
								},
								value: {
									fontSize: 10,
									color: '#fff',
									fontWeight: 'bold',
									padding: [2, 0, 0, 0]
								}
							}
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '12',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true,
							length: 5, // 第一段线的长度（从饼图到折点的距离）
							length2: 5, // 第二段线的长度（从折点到文字的距离）
						},
						data: [{
								value: 0,
								name: '追偿中',
								itemStyle: {
									color: '#FF8C00'
								}
							},
							{
								value: 0,
								name: '已结案',
								itemStyle: {
									color: '#14ff00'
								}
							}
						]
					}]
				};

				// 设置选项并渲染
				this.chart.setOption(option);
				// 注册点击事件
				this.setupChartClick(this.chart, 'echarts');
				// 响应窗口大小变化
				window.addEventListener('resize', this.handleResize);
			},
			handleResize() {
				if (this.chart) {
					this.chart.resize();
				}
			},
			fetchData() {
				apis.nonPerformingAssetStatus()
					.then((res) => {
						console.log('[不良资产案件状态占比] 接口返回数据:', res);
						const d = res && res.data ? res.data : {};
						const list = d.list || [];
						this.total = d.total || 0;
						const colors = ['#FF8C00', '#14ff00'];
						const newPieData = list.map((item, index) => ({
							value: item.value,
							name: item.name,
							itemStyle: { color: colors[index] || '#ffc700' }
						}));
						if (this.chart && newPieData.length) {
							this.chart.setOption({ series: [{ data: newPieData }] });
						}
					})
					.catch((err) => {
						console.error('不良资产案件状态占比饼图接口请求失败', err);
					});
			}
		}
	};
</script>

<style scoped>
	.ring-chart {
		width: 100%;
		height: calc(100% - 0px);
	}

	.el-card.is-always-shadow,
	.el-card.is-hover-shadow:focus,
	.el-card.is-hover-shadow:hover {
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 40%);
	}


	.ring-chart-card {
		width: 100%;
		height: calc(100% - 40px);
		background: transparent;
		border: none;
	}

	.ring-chart-card /deep/ .el-card__body {
		width: 100%;
		height: 100%;
		padding: 0px;
	}

	.chart-wrapper {
		width: 100%;
		height: calc(100% - 30px);
	}

	.chart-title {
		font-size: 14px;
		font-weight: 600;
		color: #fff;
		height: 20px;
		margin: 5px 5px;
	}
</style>